import {
  requestProducts,
  receiveProducts,
  moreProductsLoaded,
  previousProductsLoaded,
  loadingPreviousProducts,
  loadingMoreProducts,
  updatePersonalisationParams,
  setAdditionalQueryParams,
  updateAdditionalQueryParams,
  dismissFloorFilter,
  setNewSearch,
  clearNewSearch,
  refreshAdvertisementBeacons,
} from "./actionCreators";

import { applyFacets } from "../../../facets/thunks";
import { CATEGORY_PAGE } from "../../../page/constants";

export { undoSearch } from "../undo";
export {
  sendPlacementOnViewBeacon,
  sendPlacementOnLoadBeacon,
} from "../diagnostics/thunks";
export {
  loadPreviousThunk,
  loadMoreThunk,
  loadPrevious,
  loadMore,
} from "../results/thunks";
export {
  changeRangeFacet,
  applyRangeFacet,
  clearCanonicalRangeFacet,
} from "../../../facets/thunks";
export { updateImageGalleryOnboardDismissed } from "../ui/thunks";
export {
  fetchSearchThunk,
  fetchCategoryThunk,
  fetchSearch,
  fetchCategory,
  getSearchAction,
  getSearchActionCreator,
} from "../query/thunks";
import { loadPreviousThunk, loadMoreThunk } from "../results/thunks";
import { fetchSearchThunk, fetchCategoryThunk } from "../query/thunks";

export {
  requestProducts,
  receiveProducts,
  moreProductsLoaded,
  previousProductsLoaded,
  loadingPreviousProducts,
  loadingMoreProducts,
  updatePersonalisationParams,
  setAdditionalQueryParams,
  updateAdditionalQueryParams,
  dismissFloorFilter,
  setNewSearch,
  clearNewSearch,
  refreshAdvertisementBeacons,
};

const getFetchAction = ({ page: { name: pageName } }) =>
  pageName === CATEGORY_PAGE ? fetchCategoryThunk() : fetchSearchThunk();

const reapplyFacets = () => (dispatch) => dispatch(applyFacets());

export function retrySearch({ actionType, forceReapplyFacets } = {}) {
  return (dispatch, getState) => {
    switch (actionType) {
      case previousProductsLoaded.type:
        dispatch(loadPreviousThunk());
        break;
      case moreProductsLoaded.type:
        dispatch(loadMoreThunk());
        break;
      default:
        forceReapplyFacets
          ? dispatch(reapplyFacets())
          : dispatch(getFetchAction(getState()));
        break;
    }
  };
}
